import React from 'react';
import ReactDOM from 'react-dom';
import Coineus from "./Coineus";
import {Provider} from "react-redux";
import store2 from "./Coineus/redux/store";
const TWEEN = require('@tweenjs/tween.js')

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store2}>
            <Coineus/>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

function animate() {
    requestAnimationFrame(animate)
    TWEEN.update()
}

animate();